import { HorizontalSpacer } from '@superhi/design';
import styled from 'styled-components';

export const Wrapper = styled(HorizontalSpacer).attrs({
  amount: { small: 6, medium: 6, large: 6 },
})`
  display: flex;
  align-items: center;
  justify-content: flex-start;
`;
